<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { getToken } from "@/api/auth.js";
import { generateCodeChallenge } from "@/utils";
import authData from "@/data/authData.json";
import moment from "moment";
import swal from "sweetalert";


export default {
  name: "authenticate",
  mounted: async function () {
    // if (localStorage.getItem("access_token") != null || localStorage.getItem("refresh_token") != null) {
    //   window.location.replace(`${process.env.VUE_APP_DOMAINURL}/dashboard`);
    // }
    // else
    if (this.$route.query.code) {
      let authorization_code = this.$route.query.code;
      localStorage.setItem("authorization_code", authorization_code);
      await this.$store.dispatch("getToken");
      await this.$store.dispatch("getAccountSettings");
      let accountSettings = this.$store.getters["getAccountSettings"];
      let is_subscribed = accountSettings.company_details.company.is_subscribed
      if (is_subscribed) {
        this.$router.push({ path: '/rfm-dashboard' })
      }
      else {
        this.$router.push({ path: '/aben-overview' })
      }

    }
    else {
      this.$router.push({ path: '/login' })
    }
  },
  methods: {

  },
};
</script>



<template>
  <v-app class="bg-transparent">
    <v-main>

      <div>
        Authenticating ....
      </div>



    </v-main>
  </v-app>
</template>

